if (!customElements.get('sok-header')) {
  class SokHeader extends HTMLElement {
    connectedCallback() {
      this.trigger = this.querySelector('[data-sok-mega-trigger]');
      this.mega = this.querySelector('[data-sok-mega]');
      this.veil = this.parentElement.querySelector('[data-sok-mega-veil]');
      this.track = this.querySelector('[data-sok-mega-track]');
      this.prev = this.querySelector('[data-sok-mega-prev]');
      this.next = this.querySelector('[data-sok-mega-next]');

      document.addEventListener('sok:header:hide', () => this.classList.add('is-hidden'));
      document.addEventListener('sok:header:show', () => this.classList.remove('is-hidden'));
      this.trackHeights();

      if (!this.trigger || !this.mega) return;

      // Hover menus only make sense with a mouse; touch users go straight to the collection.
      this.canHover = window.matchMedia('(hover: hover) and (min-width: 1040px)');

      this.trigger.addEventListener('mouseenter', () => this.canHover.matches && this.open());
      this.trigger.addEventListener('focus', () => this.canHover.matches && this.open());
      this.addEventListener('mouseleave', () => this.close());
      this.mega.addEventListener('mouseenter', () => clearTimeout(this.closeTimer));
      this.addEventListener('focusout', (event) => {
        if (!this.contains(event.relatedTarget)) this.close(0);
      });
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && this.isOpen) {
          this.close(0);
          this.trigger.focus();
        }
      });

      this.prev?.addEventListener('click', () => this.scrollTrack(-1));
      this.next?.addEventListener('click', () => this.scrollTrack(1));
      this.track?.addEventListener('scroll', () => this.updateArrows(), { passive: true });
      this.updateArrows();
    }

    // Sticky layouts below the header (product gallery, anchor offsets) read these.
    trackHeights() {
      const bar = this.querySelector('.sok-header__bar');
      const announcement = document.querySelector('.sok-announcement');
      const root = document.documentElement.style;
      const update = () => {
        root.setProperty('--sok-header-height', `${Math.round(bar.getBoundingClientRect().height)}px`);
        root.setProperty('--sok-announcement-height', `${announcement ? Math.round(announcement.getBoundingClientRect().height) : 0}px`);
      };
      update();
      if ('ResizeObserver' in window) {
        const observer = new ResizeObserver(update);
        observer.observe(bar);
        if (announcement) observer.observe(announcement);
      }
    }

    get isOpen() {
      return this.classList.contains('is-mega-open');
    }

    open() {
      clearTimeout(this.closeTimer);
      if (this.isOpen) return;
      this.classList.add('is-mega-open');
      this.veil?.classList.add('is-open');
      this.trigger.setAttribute('aria-expanded', 'true');
      requestAnimationFrame(() => this.updateArrows());
    }

    close(delay = 120) {
      clearTimeout(this.closeTimer);
      this.closeTimer = setTimeout(() => {
        this.classList.remove('is-mega-open');
        this.veil?.classList.remove('is-open');
        this.trigger.setAttribute('aria-expanded', 'false');
      }, delay);
    }

    scrollTrack(direction) {
      const card = this.track.firstElementChild;
      if (!card) return;
      const step = card.getBoundingClientRect().width + 16;
      this.track.scrollBy({ left: direction * step, behavior: 'smooth' });
    }

    updateArrows() {
      if (!this.track || !this.prev || !this.next) return;
      const max = this.track.scrollWidth - this.track.clientWidth - 2;
      this.prev.disabled = this.track.scrollLeft <= 2;
      this.next.disabled = this.track.scrollLeft >= max;
    }
  }

  customElements.define('sok-header', SokHeader);
}
